import { router } from 'expo-router'
import { FormattedMessage } from 'react-intl'

import { Modal } from '@/src/elements/modal/Modal'
import { useOnChange } from '@/src/general/hooks/useOnChange'

import type { TGetCommunityApiData } from '../../../api/getCommunity.types'
import { COMMUNITY_LIFETIME } from '../../../models/community.constants'
import { useLeaveCommunityMutation } from '../../../services/useLeaveCommunityMutation'

type TCommunityLeaveProps = {
  id: number
  action?: string
  community?: TGetCommunityApiData
  showCommunityLeaveModal: boolean
  setShowCommunityLeaveModal: (show: boolean) => void
}

export const CommunityLeave = ({
  id,
  action,
  community,
  showCommunityLeaveModal,
  setShowCommunityLeaveModal,
}: TCommunityLeaveProps) => {
  const leaveCommunity = useLeaveCommunityMutation()

  useOnChange(action, () => {
    if (action === 'leave') setShowCommunityLeaveModal(true)
  })

  return (
    <Modal
      title={
        <FormattedMessage
          id="community.leave.confirm"
          values={{ lifetime: community?.lifetime || COMMUNITY_LIFETIME.EVERLASTING }}
        />
      }
      showCancelButton
      showModal={showCommunityLeaveModal}
      onConfirm={() => {
        if (action === 'leave') {
          router.setParams({ action: undefined })
        }
        setShowCommunityLeaveModal(false)
        leaveCommunity.mutate({ id, lifetime: community?.lifetime })
      }}
      onCancel={() => {
        if (action === 'leave') {
          router.setParams({ action: undefined })
        }
        setShowCommunityLeaveModal(false)
      }}
      classNames={{ title: 'px-8' }}
      colors="danger"
    />
  )
}
